export { default as translations } from './translations.json';

/**
 * Filter location suggestions by query.
 * Client-side filtering for instant feedback.
 * @param {Object[]} locations
 * @param {string} query
 * @returns {Object[]}
 */
export const filterLocations = (locations, query) => {
  if (!Array.isArray(locations)) return [];
  if (!query?.trim()) return locations;
  const q = query.toLowerCase().trim();
  return locations.filter(
    l => l.label?.toLowerCase().includes(q) || l.location?.toLowerCase().includes(q)
  );
};

/**
 * Format location for display.
 * @param {Object} location — { label, location }
 * @returns {string}
 */
export const formatLocationLabel = (location) =>
  location?.label || location?.location || '';

/**
 * Validate popular location config entry.
 * @param {Object} loc
 * @returns {string|null}
 */
export const validateLocationEntry = (loc) => {
  if (!loc?.label) return 'label required';
  if (!loc.coordinates?.lat || !loc.coordinates?.lng) return 'coordinates.lat and lng required';
  return null;
};
